import { KYMW0C00Model } from '../kymw0c00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像情報管理を取得するサービス
 *
 * @export GetImageGroupInfoService
 * @class GetImageGroupInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageGroupInfoService extends PlessJsonResponderSub<any> {

  private imageID: string;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetImageGroupInfoService
   */
  private model: KYMW0C00Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetImageGroupInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageGroupInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageID: this.imageID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageGroupInfoService
   */
  execute(model: any, imageId: string, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.imageID = imageId;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetImageGroupInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageGroupInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
